import classNames from 'classnames';

import { Card, GridCol, GridRow, isDefinedString } from '@client/toolkit';

export type AreaWidgetProps = {
  label?: string;
  subtitle?: string;
  total?: React.ReactNode;
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  primaryLabel?: React.ReactNode;
  secondaryLabel?: React.ReactNode;
  dense?: boolean;
};

export function AreaWidget({
  label,
  subtitle,
  total,
  primary,
  secondary,
  primaryLabel,
  secondaryLabel,
  dense = false,
}: AreaWidgetProps) {
  const totalTitle = isDefinedString(total) ? total : undefined;

  const primaryLabelTitle = isDefinedString(primaryLabel) ? primaryLabel : undefined;
  const primaryTitle = isDefinedString(primary) ? primary : undefined;

  const secondaryLabelTitle = isDefinedString(secondaryLabel) ? secondaryLabel : undefined;
  const secondaryTitle = isDefinedString(secondary) ? secondary : undefined;

  return (
    <Card variant="elevated" className="px-4 pt-3 pb-4">
      <div className="mb-2">
        <div className="flex items-baseline gap-2 mb-1">
          <span className="uppercase font-bold text-xs text-white">{label}</span>
          {subtitle && (
            <span className="text-[#8a8a8a]" style={{ fontSize: '0.65rem' }}>
              {subtitle}
            </span>
          )}
        </div>

        <div className="flex items-center space-x-2 text-lg font-bold" title={totalTitle}>
          {total}
        </div>
      </div>

      <GridRow cols={!dense ? 3 : 2} spacingX={2} spacingY={1} className={classNames('text-sm', dense && 'pr-2.5')}>
        <GridCol span={1} className="text-white" title={primaryLabelTitle}>
          {primaryLabel}
        </GridCol>
        <GridCol span={1} className="font-medium text-right text-white" title={primaryTitle}>
          {primary}
        </GridCol>
        {!dense && <GridCol span={1} />}

        <GridCol span={1} className="text-white" title={secondaryLabelTitle}>
          {secondaryLabel}
        </GridCol>
        <GridCol span={1} className="font-medium text-right text-white" title={secondaryTitle}>
          {secondary}
        </GridCol>
        {!dense && <GridCol span={1} />}
      </GridRow>
    </Card>
  );
}
